import React from 'react'
import { useEffect, useState } from 'react'
import { SWAN_STYLE_KEY_MAP, ScreenClassProvider } from '@vp/swan'
import { useSwanStyleKeys, LoggerProvider, useLogger } from '@vp/ubik-context'
import { TrackingProvider } from '../../hooks/trackingContext'
import { CampaignProvider } from '@vp/campaign-callouts'
import TilesSection from './TilesSection'
import { isBrowser } from '../../shared'
import { ContentfulContextProvider, DebugSection, ContentfulLink } from '@vp/mcs-react-tools'
import { FragmentLogger } from '@vp/ubik-logging'
import { type AppProps } from '../../types/homepageFeatureTileRow'
export const HomepageFeatureTileRow = (props: AppProps) => {
  const [hashExists, setHashExists] = useState(false)
  useEffect(() => {
    setHashExists(isBrowser() && window.location.hash !== '')
  }, [])

  useSwanStyleKeys([SWAN_STYLE_KEY_MAP.core, SWAN_STYLE_KEY_MAP.grid, SWAN_STYLE_KEY_MAP.carousel, SWAN_STYLE_KEY_MAP.standardTile, SWAN_STYLE_KEY_MAP.utility])

  const logger = useLogger() as FragmentLogger

  logger.setContext({
    ...props,
    name: 'feature-tile-row-fragment',
  })

  logger.info('Rendering Feature Tile Row Fragment')

  const search = typeof window !== 'undefined' ? window.location.search : ''

  const shouldRender =
    props.tileRowData && !!((!props.useNewTiles && props.tileRowData.productTiles?.length) || (props.useNewTiles && props.tileRowData.tiles?.length))
  const tileList = props?.useNewTiles ? props.tileRowData?.tiles : props.tileRowData?.productTiles

  return (
    <LoggerProvider>
      <ContentfulContextProvider space={props.contentfulMetadata?.spaceId}>
        <ContentfulLink id={props.contentfulMetadata?.contentful_id} />
        <DebugSection contentfulMetadata={props.contentfulMetadata} availability={props.debugAvailability} search={search} />
        <TrackingProvider canonicalUrl="https://www.vistaprint.com/">
          <CampaignProvider tenant={props.tenant} locale={props.locale}>
            <ScreenClassProvider>
              {shouldRender && (
                <TilesSection
                  tileImageLoadingStrategy={props.eagerlyLoad || hashExists ? 'eager' : 'lazy'}
                  tileData={{ ...props.tileRowData, tileList }}
                  tileRow={props.tileRow}
                  tileTrackingZone={props.tileTrackingZone}
                  id={props.tileRowId}
                  enableCampaignCallouts={props.enableCampaignCallouts}
                  useNewTiles={props.useNewTiles}
                  gridToggle={props.gridToggle}
                  carouselA11yText={props.carouselA11yText}
                  locale={props.locale}
                />
              )}
            </ScreenClassProvider>
          </CampaignProvider>
        </TrackingProvider>
      </ContentfulContextProvider>
    </LoggerProvider>
  )
}
